<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button
            type="text"
            @click="goBack()"
            v-if="questionnaireInfo.Type === 1"
            >返回问卷列表</el-button
          >
          <el-button
            type="text"
            @click="goBack()"
            v-if="questionnaireInfo.Type === 2"
            >返回投票列表</el-button
          >
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportData()"
          >
            导出
          </el-button>
        </div>
      </div>
      <div class="table-block" style="border-top: 0px">
        <div style="text-align: center; font-weight: 900; font-size: 32px">
          {{ questionnaireResult.QuestionnaireName }}
        </div>
        <div
          style="
            text-align: center;
            font-weight: 700;
            font-size: 18px;
            color: #f56c6c;
            margin-bottom: 15px;
          "
          v-if="false"
        ></div>
        <el-table
          ref="questionnaireResultTable"
          :data="questionnaireResult.AnswerPaperList"
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="50"
            v-if="!is_xs"
          >
          </el-table-column>
          <el-table-column property="UserName" label="用户" min-width="200">
          </el-table-column>
          <el-table-column
            :label="questionnaireInfo.Type === 1 ? '是否交卷' : '是否提交'"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.IsSubmit && questionnaireInfo.Type === 1"
                style="color: #67c23a"
              >
                <i class="el-icon-document-checked"></i>
                已交卷
              </span>
              <span
                v-if="scope.row.IsSubmit && questionnaireInfo.Type === 2"
                style="color: #67c23a"
              >
                <i class="el-icon-document-checked"></i>
                已提交
              </span>
              <span v-if="!scope.row.IsSubmit && questionnaireInfo.Type === 1">
                <i class="el-icon-document-delete"></i>
                未交卷
              </span>
              <span v-if="!scope.row.IsSubmit && questionnaireInfo.Type === 2">
                <i class="el-icon-document-delete"></i>
                未提交
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="questionnaireInfo.Type === 1 ? '交卷时间' : '提交时间'"
            width="130"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.SubmitDateTime">
                {{ scope.row.SubmitDateTime | dateformat('YYYY.MM.DD HH:mm') }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="得分"
            width="130"
            align="center"
            v-if="questionnaireResult.QuestionnaireType === 1"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.AnswerTotalScore >= questionnaireResult.PassScore
                "
                style="color: #ff6a00; font-size: 18px; font-weight: bold"
              >
                {{ scope.row.AnswerTotalScore }}
              </span>
              <span
                v-if="
                  scope.row.AnswerTotalScore < questionnaireResult.PassScore
                "
                style="color: red; font-size: 18px; font-weight: bold"
              >
                {{ scope.row.AnswerTotalScore }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130" align="right">
            <template slot-scope="scope">
              <el-link
                type="primary"
                class="cell_link"
                @click="openMarkingAnswerPaper(scope.row, scope.$index)"
              >
                <span v-if="questionnaireInfo.Type === 1">阅卷</span>
                <span v-if="questionnaireInfo.Type === 2">查看</span>
              </el-link>
              <el-link
                type="primary"
                class="cell_link"
                @click="againQuestionnaire(scope.row)"
                v-if="
                  scope.row.IsSubmit &&
                  questionnaireResult.State === 1 &&
                  questionnaireInfo.Type === 2
                "
              >
                重新提交
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 100, 200, 500, 1000]"
          :page-size="resultQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="questionnaireResultItemsCount"
          v-show="questionnaireResult.AnswerPaperList.length > 0"
        >
        </el-pagination>
      </div>
    </div>
    <MarkingAnswerPaper
      :fatherSubmitDialog="markingAnswerPaperDialog"
      ref="markingAnswerPaper"
    ></MarkingAnswerPaper>
  </div>
</template>
<script>
import questionnaireApi from '../../../../../api/wj/questionnaire'
import answerPaperApi from '../../../../../api/wj/answerPaper'
import MarkingAnswerPaper from '@/components/answerPaper/MarkingAnswerPaper.vue'
export default {
  name: 'Result',
  components: {
    MarkingAnswerPaper
  },
  data () {
    return {
      resultQuery: {
        QuestionnaireId: null,
        SkipCount: 0,
        MaxResultCount: 100,
        Sorting: null
      },
      currentPage: 1,
      pagination_layout: 'prev, pager, next',
      questionnaireResultItemsCount: 0,
      questionnaireResult: {
        AnswerPaperList: []
      }
    }
  },
  props: ['questionnaireInfo'],
  methods: {
    goBack: function () {
      if (this.questionnaireInfo.Type === 2) {
        this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
      }
      if (this.questionnaireInfo.Type === 1) {
        this.$router.push({ name: 'questionnaireManage', params: { mid: this.$route.params.mid } })
      }
    },
    refresh: function () {
      this.getQuestionnaireResult()
    },
    getQuestionnaireResult: function () {
      const _this = this
      _this.openLoading()
      questionnaireApi.getQuestionnaireResult(_this.resultQuery).then(data => {
        _this.questionnaireResult = data
        _this.questionnaireResultItemsCount = data.TotalCount
        _this.$nextTick(function () {
          _this.$refs.questionnaireResultTable.doLayout()
        })
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    indexMethod (index) {
      return index + this.resultQuery.SkipCount + 1
    },
    handleSizeChange (val) {
      this.resultQuery.MaxResultCount = val
      this.getQuestionnaireResult()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.resultQuery.SkipCount = (val - 1) * this.resultQuery.MaxResultCount
      this.getQuestionnaireResult()
    },
    markingAnswerPaper: function (item) {
      const _this = this
      _this.openLoading()
      answerPaperApi.markingAnswerPaper({
        questionnaireId: item.Id
      }).then(data => {
        _this.$message({
          type: 'success',
          message: '打分成功！',
          customClass: 'custom_message'
        })
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    openMarkingAnswerPaper: function (row, index) {
      const _this = this
      _this.$refs.markingAnswerPaper.openMarkingAnswerPaper(this.questionnaireResult.QuestionnaireId, row.AnswerPaperId, row.UserId, index, row.IsSubmit)
    },
    markingAnswerPaperDialog: function (index, newTotalScore, isSubmit) {
      if (isSubmit) {
        if (newTotalScore !== -1) {
          if (newTotalScore) {
            this.questionnaireResult.AnswerPaperList[index].AnswerTotalScore = newTotalScore
          } else {
            this.questionnaireResult.AnswerPaperList[index].AnswerTotalScore = 0
          }
        }
      }
    },
    againQuestionnaire: function (row) {
      const _this = this
      this.$confirm('确认重新答卷吗？答卷人：' + row.UserName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        questionnaireApi.againQuestionnaire({
          QuestionnaireId: _this.questionnaireResult.QuestionnaireId,
          UserId: row.UserId
        }).then(data => {
          if (data) {
            _this.getQuestionnaireResult()
            this.$message({
              type: 'success',
              message: row.UserName + ' 可以重新答卷',
              customClass: 'custom_message'
            })
          }
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    exportData: function () {
      const _this = this
      _this.openLoading()
      questionnaireApi.exportQuestionnaireResult({
        QuestionnaireId: _this.questionnaireResult.QuestionnaireId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '问卷结果'
        fileName = _this.questionnaireResult.QuestionnaireName + '-问卷结果'
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    }
  },
  computed: {

  },
  created () {
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
    this.resultQuery.QuestionnaireId = this.$route.params.qid
    this.getQuestionnaireResult()
  }
}
</script>
<style lang="less">
</style>
